'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _Links = require('../utils/Links');

var _TabIndex = require('../utils/TabIndex');

var _LinkConstants = require('./LinkConstants');

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Hide icon in tables, except on hover (#5679)
var truncatedExternalIconMixin = (0, _styledComponents.css)(['.private-table tr:not(:hover) .private-link:not(:focus) &{visibility:hidden;}']);

var DefaultExternalIcon = (0, _styledComponents2.default)(function (props) {
  var __truncated = props.truncated,
      rest = _objectWithoutProperties(props, ['truncated']);

  return _react2.default.createElement(_UIIcon2.default, rest);
}).withConfig({
  displayName: 'UILink__DefaultExternalIcon'
})(['', ''], function (_ref) {
  var truncated = _ref.truncated;
  return truncated && truncatedExternalIconMixin;
});

var UILink = (0, _memoWithDisplayName2.default)('UILink', function (props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      external = props.external,
      ExternalIcon = props.ExternalIcon,
      href = props.href,
      iconProps = props.iconProps,
      linkRef = props.linkRef,
      _onClick = props.onClick,
      _onKeyDown = props.onKeyDown,
      rel = props.rel,
      role = props.role,
      tabIndex = props.tabIndex,
      target = props.target,
      to = props.to,
      truncate = props.truncate,
      truncateStringProps = props.truncateStringProps,
      underline = props.underline,
      use = props.use,
      rest = _objectWithoutProperties(props, ['children', 'className', 'disabled', 'external', 'ExternalIcon', 'href', 'iconProps', 'linkRef', 'onClick', 'onKeyDown', 'rel', 'role', 'tabIndex', 'target', 'to', 'truncate', 'truncateStringProps', 'underline', 'use']);

  if (process.env.NODE_ENV !== 'production') {
    if (to != null) {
      _devLogger2.default.warn({
        message: 'UILink: The `to` prop is a no-op. Did you mean `href`? (`to="' + to + '"`)',
        key: 'UILink: to'
      });
    }
  }

  var defaultLinkRef = (0, _react.useRef)(null);

  var computedTarget = (0, _Links.getTarget)(external, target);
  var computedRel = (0, _Links.getRel)(rel, computedTarget);
  var computedRole = href ? undefined : role || 'button';
  var externalLinkIcon = external ? _react2.default.createElement(ExternalIcon, _extends({
    'aria-label': _I18n2.default.text('salesUI.UILink.externalTitle'),
    name: 'externalLink'
  }, iconProps, {
    className: (0, _classnames2.default)('private-link--external__icon', iconProps && iconProps.className),
    truncated: truncate
  })) : null;

  if (process.env.NODE_ENV !== 'production') {
    (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UILink');
  }

  var wrappedChildren = truncate ? _react2.default.createElement(
    _UITruncateString2.default,
    _extends({
      useFlex: true,
      fixedChildren: externalLinkIcon
    }, truncateStringProps),
    children
  ) : children;

  var renderedLink = _react2.default.createElement(
    'a',
    _extends({}, rest, {
      className: (0, _classnames2.default)('private-link', _LinkConstants.UNDERLINE_CLASSES[underline], _LinkConstants.USE_CLASSES[use], { 'private-link--disabled': disabled }, className),
      onClick: function onClick(evt) {
        if (disabled) {
          evt.preventDefault();
          evt.stopPropagation();
        } else {
          if (_onClick) _onClick(evt);
        }
      },
      onKeyDown: function onKeyDown(evt) {
        // Simulate click on Spacebar, to emulate button behavior
        var key = evt.key;


        if (_onKeyDown) _onKeyDown(evt);
        if (!_onClick) return;

        // Ignore keydown events that bubbled up
        if (evt.target !== (linkRef || defaultLinkRef).current) return;

        if (key === ' ') {
          if (disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            return;
          }
          _onClick(evt);

          // Prevent scrolling
          evt.preventDefault();
        }
      },
      href: disabled ? undefined : (0, _UnsafeUrl.getSafeUrl)(href),
      ref: linkRef || defaultLinkRef,
      rel: computedRel,
      role: computedRole,
      tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
      target: computedTarget,
      'aria-disabled': disabled
    }),
    wrappedChildren,
    truncate ? null : externalLinkIcon
  );

  return (0, _Links.renderSecurityTaggedLink)(href, renderedLink);
});

UILink.propTypes = {
  children: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  external: _propTypes2.default.bool.isRequired,
  ExternalIcon: _propTypes2.default.elementType.isRequired,
  href: _validHref2.default,
  iconProps: _propTypes2.default.object,
  linkRef: _refObject2.default,
  onKeyDown: _propTypes2.default.func,
  rel: _propTypes2.default.string,
  target: _propTypes2.default.string,
  truncate: _propTypes2.default.bool.isRequired,
  truncateStringProps: _propTypes2.default.object,
  underline: _propTypes2.default.bool.isRequired,
  use: _propTypes2.default.oneOf(Object.keys(_LinkConstants.USE_CLASSES)).isRequired
};

UILink.defaultProps = {
  external: false,
  ExternalIcon: DefaultExternalIcon,
  truncate: false,
  underline: false,
  use: 'dark'
};

exports.default = UILink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/link/UILink.js
// module id = 86
// module chunks = 177